function getSessionKeyId() {
  if (typeof window === 'undefined') return null;
  let keyId = sessionStorage.getItem('blt_token_key_id');
  if (!keyId) {
    keyId = crypto.randomUUID();
    sessionStorage.setItem('blt_token_key_id', keyId);
  }
  return keyId;
}

function getSessionTokenKey() {
  const keyId = getSessionKeyId();
  return `blt_token____${keyId}`;
}

export const getStoredSessionToken = () => {
  if (typeof window === 'undefined') return null;
  return sessionStorage.getItem(getSessionTokenKey());
};

export const setSessionToken = (token) => {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(getSessionTokenKey(), token);
};

export const clearSessionToken = () => {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(getSessionTokenKey());
};

export const getSessionToken = async (subdomain) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_MIRROR_CORE_URL}/mirror-core/v1/private/events/${subdomain}/sessions`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    if (!response.ok) {
      throw new Error('Failed to get session token');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error getting session token:', error);
    throw error;
  }
};
